export const categories = [
  {
    id: 1,
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
    description: 'Sneakers, Yeezy, Nike, Adidas & more',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-02',
    description: 'Streetwear hoodies & premium sweaters',
  },
  {
    id: 3,
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-03',
    description: 'Graphic tees, basics & designer styles',
  },
  {
    id: 4,
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-04',
    description: 'Bombers, denim, varsity & puffers',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-05',
    description: 'Jeans, cargos, shorts & trousers',
  },
  {
    id: 6,
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-06',
    description: 'Caps, beanies, bucket hats & more',
  },
  {
    id: 7,
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-07',
    description: 'Matching tracksuits & coordinated outfits',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-08',
    description: 'Comfortable essentials & designer underwear',
  },
  {
    id: 9,
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-09',
    description: 'Sports jerseys, football & basketball',
  },
  {
    id: 10,
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-10',
    description: 'Watches, jewelry, sunglasses & more',
  },
  {
    id: 11,
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-11',
    description: 'Backpacks, crossbody, totes & luggage',
  },
  {
    id: 12,
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-12',
    description: 'Leather belts, designer & casual styles',
  },
  {
    id: 13,
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-13',
    description: 'Designer fragrances & niche scents',
  },
  {
    id: 14,
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-14',
    description: 'Tech gadgets, home goods & miscellaneous',
  },
];